import { formatDate, formatToDevanagariStyle } from "@/utilities/helper"

export const columns = [
  {
    accessorKey: "sale_day",
    header: "Sale Day",
    // cell: ({ row }) => `${formatDate(row.original.sale_date)}`,
  },
  {
    accessorKey: "sale_date",
    header: "Sale Date",
    // cell: ({ row }) => `${formatDate(row.original.sale_date)}`,
  },
  {
    accessorKey: "sale_date_nepali",
    header: "Nepali Sale Date",
    // cell: ({ row }) => `${formatDate(row.original.sale_date)}`,
  },
  {
    accessorKey: "total_sales",
    header: "Sales",
    cell: ({ row }) => (
      <>
        <div>
          Total: Rs.{" "}
          <span className="font-semibold">
            {formatToDevanagariStyle(row.original.total_sales)}
          </span>
        </div>
        {row.original.payment_methods.map((method) => (
          <div>
            <span className="capitalize">{method.method}</span>: Rs.{" "}
            {formatToDevanagariStyle(method.total)}
          </div>
        ))}
        <div>
          Sales Return: Rs.{" "}
          <span className="font-semibold">
            {formatToDevanagariStyle(row.original.sales_return)}
          </span>
        </div>
      </>
    ),
  },
  { accessorKey: "total_orders", header: "Total Orders" },
]
